module.exports = __webpack_public_path__ + "static/img/ll01.e98f3a15.png";